module.exports = __webpack_public_path__ + "static/Grid_Example-45e3daf3f47f578994f7823094a5bd5c.png";